<div class="margin-bottom-5">
    <h3>{{ 'knowYourCustomerDetails.options' | transloco }}</h3>
    @if (isSubmitted) {
    <div class="flex-container-vertical-center">
        <span class="flex-item-3"></span>
        <span class="flex-item-4">{{ 'common.labels.requested' | transloco }}</span>
        <span class="flex-item-4">{{ 'knowYourCustomerDetails.completed' | transloco }}</span>
    </div>
    }
    <div class="flex-container-vertical-center">
        <span class="flex-item-3">{{ 'knowYourCustomerDetails.creditBureauAndPhoneValidationWaterfall' | transloco }}</span>
        <span [ngClass]="isSubmitted ? 'flex-item-4' : 'flex-item-2'"
            data-testid="credit-bureau-validation-checkbox"><mat-checkbox disabled="true"
                [checked]="order.knowYourCustomerCriteria?.shouldDoCreditPhoneWaterfallValidation ?? false"></mat-checkbox></span>
        @if (isSubmitted) {
        <span class="flex-item-4"></span>
        }
    </div>
    <div class="flex-container-vertical-center">
        <span class="flex-item-3">{{ 'knowYourCustomerDetails.creditBureauValidation' | transloco }}</span>
        <span [ngClass]="isSubmitted ? 'flex-item-4' : 'flex-item-2'"
            data-testid="credit-bureau-validation-checkbox"><mat-checkbox disabled="true"
                [checked]="order.knowYourCustomerCriteria?.shouldDoCreditBureauValidation ?? false"></mat-checkbox></span>
        @if (isSubmitted) {
        <span class="flex-item-4" data-testid="credit-bureau-validation-completed-checkbox"><mat-checkbox
                disabled="true"
                [checked]="!!order.knowYourCustomerCriteria?.creditBureauValidationCompletedDate"></mat-checkbox></span>
        }
    </div>
    <div class="flex-container-vertical-center">
        <span class="flex-item-3">{{ 'knowYourCustomerDetails.phoneNumberVerification' | transloco }}</span>
        <span [ngClass]="isSubmitted ? 'flex-item-4' : 'flex-item-2'"
            data-testid="phone-number-validation-checkbox"><mat-checkbox disabled="true"
                [checked]="order.knowYourCustomerCriteria?.shouldDoPhoneNumberValidation ?? false"></mat-checkbox></span>
        @if (isSubmitted) {
        <span class="flex-item-4" data-testid="phone-number-validation-completed-checkbox"><mat-checkbox disabled="true"
                [checked]="!!order.knowYourCustomerCriteria?.phoneNumberValidationCompletedDate"></mat-checkbox></span>
        }
    </div>
    <div class="flex-container-vertical-center">
        <span class="flex-item-3">{{ 'knowYourCustomerDetails.documentVerificationWithBiometrics' | transloco }}</span>
        <span [ngClass]="isSubmitted ? 'flex-item-4' : 'flex-item-2'"
            data-testid="identity-verification-checkbox"><mat-checkbox disabled="true"
                [checked]="order.knowYourCustomerCriteria?.shouldDoIdentityVerification ?? false"></mat-checkbox></span>
        @if (isSubmitted) {
        <span class="flex-item-4" data-testid="identity-verification-completed-checkbox"><mat-checkbox disabled="true"
                [checked]="!!order.knowYourCustomerCriteria?.identityVerificationCompletedDate"></mat-checkbox></span>
        }
    </div>
    @if (order.knowYourCustomerCriteria?.shouldDoIdentityVerification) {
    <div class="flex-container">
        <span class="flex-item-3 idv-language-label">
            {{ 'knowYourCustomerDetails.dvsLanguage' | transloco }} {{ (order.knowYourCustomerCriteria?.sendIdvInFrench ? 'common.labels.french' : 'common.labels.english') | transloco }}
        </span>
    </div>
    }
    @if (shouldShowPepsAndSanctions) {
    <div class="flex-container-vertical-center">
        <span class="flex-item-3">{{ 'knowYourCustomerDetails.pepsAndSanctionsCheck' | transloco }}</span>
        <span [ngClass]="isSubmitted ? 'flex-item-4' : 'flex-item-2'"
            data-testid="peps-and-sanctions-checkbox"><mat-checkbox disabled="true"
                [checked]="order.knowYourCustomerCriteria?.shouldDoPepsAndSanctions ?? false"></mat-checkbox></span>
        @if (isSubmitted) {
        <span class="flex-item-4" data-testid="peps-and-sanctions-completed-checkbox"><mat-checkbox disabled="true"
                [checked]="!!order.knowYourCustomerCriteria?.pepsAndSanctionsCompletedDate"></mat-checkbox></span>
        }
    </div>
    }
    @if (showCompliance) {
        <h3>{{ 'knowYourCustomerDetails.compliance' | transloco }}</h3>
        <div class="flex-container-vertical-center">
            <span class="flex-item-3">{{ 'knowYourCustomerDetails.fintracCompliant' | transloco }}</span>
            <span class="flex-item-4">{{ fintracCompliant ? "Yes" : "No" }}</span>
            <span class="flex-item-4"></span>
        </div>
        @if (fintracCompliant) {
        <div class="flex-container-vertical-center">
            <span class="flex-item-3">{{ 'knowYourCustomerDetails.fintracMethod' | transloco }}</span>
            <span class="flex-item-4">{{ fintracMethod }}</span>
            <span class="flex-item-4"></span>
        </div>
        }
    }
</div>